import {usePromotion} from '@/context/Promotion/PromotionContext'
import {GiftItemReward, PromotionCondition} from '@/types/promotion'
import {buyOptions, giftItemOptions} from '@/utils/constants/promotionConstants'
import {toRewardsUpdate} from './toRewardsUpdate'
import {useRewardValidations} from './RewardValidations.js'

type UseRewardGiftItemArgs = {
  promotionCondition: PromotionCondition
  rewardIndex?: number
}

export const useRewardGiftItem = ({promotionCondition, rewardIndex = 0}: UseRewardGiftItemArgs) => {
  const {updateCondition} = usePromotion()
  const {hasValueLayerError} = useRewardValidations(promotionCondition, rewardIndex)
  const reward = promotionCondition.rewards?.[rewardIndex] as GiftItemReward

  const updateReward = (update: Partial<GiftItemReward>) => {
    const currentReward = promotionCondition?.rewards?.[rewardIndex] ?? {}

    updateCondition({
      sequence: promotionCondition.sequence,
      rewards: toRewardsUpdate({...currentReward, ...update} as GiftItemReward, rewardIndex),
    })
  }

  const handleQuantityChange = values => updateReward({quantity: Number(values?.[0]?.id)})
  const handleGiftItemChange = values => updateReward({items: [values?.[0]?.id]})

  return {
    quantityOptions: buyOptions,
    giftItemOptions,
    quantityValue: buyOptions.filter(item => item.id === reward?.quantity?.toString()),
    giftItemValue: giftItemOptions.filter(item => reward?.items?.find(id => id === item.id)),
    isError: hasValueLayerError(),
    handleQuantityChange,
    handleGiftItemChange,
  }
}
